import { FieldControllerProps, TranslatableText } from '@dreryk/react-common';
import { Checkbox, ClassNameProp } from '@dreryk/react-components';

type UsingParentAddressDataCheckboxProps = FieldControllerProps<'usingParentAddressData', boolean> &
   ClassNameProp & {
      readonly label: TranslatableText;
   };

export const UsingParentAddressDataCheckbox = (props: UsingParentAddressDataCheckboxProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
   });

   return (
      <Checkbox
         testId={props.name}
         label={props.label}
         controller={controller}
         defaultValue={props.defaultValue}
         className={props.className}
      />
   );
};
